<p-toast key="glToast" position="top-center"></p-toast>
@if (pragmaAgentEnabled && embedReady() && hasSuperAdminPermission() === true) {
    <pragma-agent
        [attr.api-url]="pragmaAgentApiUrl"
        [attr.token]="agentToken"
        [attr.theme]="isDarkMode ? 'dark' : 'light'"
        title="Ask Pragma Maritime"
        placeholder="Ask a question..."
        position="bottom-right"
    >
    </pragma-agent>
}

@if (pragmaAgentEnabled && embedReady() && hasSuperAdminPermission() === true) {
    <pragma-insight
        [attr.api-url]="pragmaAgentApiUrl"
        [attr.token]="agentToken"
        [attr.theme]="isDarkMode ? 'dark' : 'light'"
    ></pragma-insight>
}

<router-outlet></router-outlet>

<p-drawer
    [visible]="sidebarVisible()"
    (visibleChange)="toggleSidebar($event)"
    appendTo="body"
    [blockScroll]="sidebarOptions().blockScroll"
    [modal]="sidebarOptions().modal"
    [position]="sidebarOptions().position"
    [style]="sidebarOptions().style"
    [styleClass]="sidebarOptions().styleClass"
    [autoZIndex]="sidebarOptions().autoZIndex"
    [baseZIndex]="sidebarOptions().baseZIndex"
    [dismissible]="sidebarOptions().dismissible"
    [fullScreen]="sidebarOptions().fullScreen"
>
    <ng-template pTemplate="header">
        @if (headerTemplate(); as template) {
            <ng-container *ngTemplateOutlet="template"></ng-container>
        }
    </ng-template>

    <ng-template pTemplate="content">
        @if (contentTemplate(); as template) {
            <ng-container *ngTemplateOutlet="template"></ng-container>
        }
    </ng-template>

    <ng-template pTemplate="footer">
        @if (footerTemplate(); as template) {
            <ng-container *ngTemplateOutlet="template"></ng-container>
        }
    </ng-template>
</p-drawer>
